"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _antd = require("antd");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var TreeNode = _antd.TreeSelect.TreeNode,
  TreeSelect = _antd.TreeSelect._InternalPanelDoNotUseOrYouWillBeFired;
var Demo = function Demo() {
  var _useState = (0, _react.useState)(undefined),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var onChange = function onChange() {
    setValue(value);
  };
  return /*#__PURE__*/_react.default.createElement(TreeSelect, {
    disabled: true,
    showSearch: true,
    style: {
      width: '100%'
    },
    value: value,
    dropdownStyle: {
      maxHeight: 400,
      overflow: 'auto'
    },
    placeholder: "Please select",
    allowClear: true,
    treeDefaultExpandAll: true,
    onChange: onChange
  }, /*#__PURE__*/_react.default.createElement(TreeNode, {
    value: "parent 1",
    title: "parent 1"
  }, /*#__PURE__*/_react.default.createElement(TreeNode, {
    value: "parent 1-0",
    title: "parent 1-0"
  }, /*#__PURE__*/_react.default.createElement(TreeNode, {
    value: "leaf1",
    title: "leaf1"
  }), /*#__PURE__*/_react.default.createElement(TreeNode, {
    value: "leaf2",
    title: "leaf2"
  })), /*#__PURE__*/_react.default.createElement(TreeNode, {
    value: "parent 1-1",
    title: "parent 1-1"
  }, /*#__PURE__*/_react.default.createElement(TreeNode, {
    value: "leaf3",
    title: 'leaf3'
  }))));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorTextDisabled', 'colorBgContainerDisabled'],
  key: 'disabled'
};
var _default = exports.default = componentDemo;